module.exports = __webpack_public_path__ + "img/ic_course_active.cd88ef74.png";